import Modal from 'react-bootstrap/Modal';
import React, {useEffect} from 'react';
import useDispathModel from '../hooks/useDispathModel';
import DataTableComponent from 'web/components/DataTableComponent';
import moment from 'moment';

/**
 *
 */
export default function DispatchHistoryModel({
  isOpen = false,
  onOpenChange = () => {},
  searchId = null,
  currentStartTime = null,
  currentEndTime = null,
}) {
  const {assignmentEmployee, fetchAssignmentEmployee, statusEnum} =
    useDispathModel();

  useEffect(() => {
    if (isOpen && searchId) {
      fetchAssignmentEmployee(searchId);
    }
  }, [isOpen, searchId]);

  const columns = [
    {data: 'employeeName', title: '指派人員'},
    {
      data: (row, type, val, meta) => {
        return {
          isAccountable: row.isAccountable,
          workEndTime: row.workEndTime,
        };
      },
      title: '指派角色',
    },
    {data: 'workStartTime', title: '工作開始時間'},
    {data: 'workEndTime', title: '工作結束時間'},
  ];

  const checkStatus = (isAccountable, workEndTime) => {
    if (!moment(currentEndTime).isSame(moment(workEndTime))) {
      return statusEnum.hasWorkEndTime;
    }
    if (Boolean(isAccountable)) {
      return statusEnum.isAccountable;
    } else {
      return statusEnum.isNotAccountability;
    }
  };

  const dataSlots = {
    1: ({isAccountable, workEndTime}) => {
      const status = checkStatus(isAccountable, workEndTime);

      return (
        <div className={`status  mb-2 ${status.className} `}>
          <span>{status.title}</span>
        </div>
      );
    },
  };

  return (
    <Modal
      centered
      size="md"
      show={isOpen}
      onHide={() => onOpenChange(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title className="modal-title fs-5">指派紀錄 </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body datatable-container">
        <div className="datatable__data">
          <DataTableComponent
            className="display table table-hover align-middle nowrap"
            data={assignmentEmployee}
            columns={columns}
            slots={dataSlots}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
